export default __webpack_public_path__ + "static/media/icons8-event-accepted-100.f5468bb7.svg";